import {
    AuthFormInput2,
    AuthFormInputSpan2,
    Body, Cell,
    CellTitle,
    CellValue,
    Footer, FormButton2, FormButtonCancel2, Modal,
    ModalBg,
    ModalContent,
    Row,
    Title
} from "../../withdraw/modal/styles";
import {ContainerRow} from "../../../components/Container";
import {
    errorView, postPhoneSentCodeVerify, postPhoneVerify,
    postWithdrawSendCode
} from "../../../services/app";
import React, {useEffect, useState} from "react";
import {useApp} from "../../../contexts";
import {Form} from "antd";
import produce from "immer";
import {FormPhoneInput, Text} from "./styles";
import PhoneInputNumber from "../../../components/PhoneInputNumber";

export default function ModalPhoneVerify(props) {
    const {
        T, setLoading, setAlert
    } = useApp();
    const onClose = props.onClose;
    const [sentOtp, setSentOtp] = useState(0);
    const [phone, setPhone] = useState({
        "countryCode": "",
        "phone": "",
    });
    const [otp, setOtp] = useState("");
    const [mode, setMode] = useState(false);
    const [errors, setErrors] = useState([]);


    useEffect(() => {
        const timer = setInterval(() => {
            setSentOtp((prevState) => {
                if (prevState > 0) {
                    return prevState - 1;
                }
                return prevState;
            });
        }, 1000);
        return () => {
            clearInterval(timer);
        }
    }, []);

    const onSentOtp = async () => {
        if (!phone.countryCode || !phone.phone) {
            return;
        }
        setLoading(true);
        const result = await postPhoneSentCodeVerify(phone.countryCode.toUpperCase(), phone.phone);
        if (result.status === 200) {
            setSentOtp(180);
        } else {
            setErrors(result?.data?.error?.validates || []);
            if (!(result?.data?.error?.validates || []).length) {
                setAlert({
                    type: 'error',
                    text: result?.data?.error?.message || T("Some error happened. Please try again later.")
                });
            }
        }
        setLoading(false);
    }

    const onSubmit = async () => {
        setLoading(true);
        const result = await postPhoneVerify( otp);
        if (result.status === 200) {
            onClose('success');
        } else {
            //onClose("error");
            setErrors(result?.data?.error?.validates || []);
            if (!(result?.data?.error?.validates || []).length) {
                setAlert({
                    type: 'error',
                    text: result?.data?.error?.message || T("Some error happened. Please try again later.")
                });
            }
        }
        setLoading(false);
    }

    return (
        <Modal>
            <ModalBg onClose={() => onClose()} />
            <ModalContent>
                <Title>{T("Phone Verification")}</Title>
                {mode === 'verify' ? (
                    <>
                        <Body style={{marginTop: 90}}>
                            <Row>
                                <Cell>
                                    <CellTitle>{T("Phone number")}</CellTitle>
                                    <CellValue>
                                        <Form.Item {...errorView(errors, "phone")} name={'phone'}
                                                   style={{width: '100%'}}>
                                                     <PhoneInputNumber
                                                        onChange={({ phone, countryCode }) => {
                                                        setPhone({
                                                            phone: phone,
                                                            countryCode,
                                                        });
                                                        setErrors(
                                                            produce((draft) => {
                                                            draft.splice(
                                                                draft.findIndex((item) => item.key === "phone"),
                                                                1
                                                            );
                                                            })
                                                        );
                                                        }}
                                                        placeholder={T("Please enter your phone number")}
                                                    />
                                                    {/* <InputPhone
                                                        value={phone.phone}
                                                        onChange={(value, data, event, formattedValue) => {
                                                        const { countryCode, dialCode } = data;
                                                        setPhone({
                                                            phone: value.slice(dialCode.length, value.length),
                                                            countryCode,
                                                        });
                                                        setErrors(
                                                            produce((draft) => {
                                                            draft.splice(
                                                                draft.findIndex((item) => item.key === "phone"),
                                                                1
                                                            );
                                                            })
                                                        );
                                                        }}
                                                        placeholder={T("Please enter your phone number")}
                                                    /> */}
                                            {/* <FormPhoneInput value={phone}
                                                            onChange={event => {
                                                                setPhone(event);
                                                                setErrors(produce(draft => {
                                                                    draft.splice(draft.findIndex(item => item.key === 'phone'), 1)
                                                                }));
                                                            }}
                                                            placeholder={T("Please enter your phone number")}/> */}
                                        </Form.Item>
                                    </CellValue>
                                </Cell>
                            </Row>
                            <Row style={{marginTop: 20}}>
                                <Cell>
                                    <CellTitle>{T("Enter Verification Code")}</CellTitle>
                                    <CellValue>
                                        <div style={{position: "relative", flex: 1}}>
                                            <Form.Item {...errorView(errors, "verificationCode")} name={'otp'}
                                                       style={{marginTop: 20}}>
                                                <AuthFormInput2 value={otp} onChange={event => {
                                                    setOtp(event.target.value);
                                                    setErrors(produce(draft => {
                                                        draft.splice(draft.findIndex(item => item.key === 'verificationCode'), 1)
                                                    }));
                                                }}
                                                                readOnly={sentOtp <= 0}
                                                                placeholder={sentOtp <= 0 ? T("Click “Send Code”") : T("Please enter code")}/>
                                            </Form.Item>
                                            <AuthFormInputSpan2
                                                className={'send-code'}
                                                style={{top: 33, ...(!phone.countryCode || !phone.phone ? {color: '#8a8a8a'} : {})}}
                                                onClick={() => {
                                                    if (sentOtp <= 0) {
                                                        onSentOtp().then();
                                                    }
                                                }}>{sentOtp > 0 ? `${sentOtp}s` : T("Send Code")}</AuthFormInputSpan2>
                                        </div>
                                    </CellValue>
                                </Cell>
                            </Row>
                        </Body>
                        <Footer>
                            <ContainerRow>
                                <FormButtonCancel2 style={{marginRight: 8}}
                                                   onClick={() => onClose()}>{T("Cancel")}</FormButtonCancel2>
                                <FormButton2 disabled={!otp || !phone.countryCode || !phone.phone}
                                             style={{marginLeft: 8}}
                                             onClick={() => onSubmit()}>{T("Confirm")}</FormButton2>
                            </ContainerRow>
                        </Footer>
                    </>
                ) : (
                    <ContainerRow style={{flexDirection: "column", alignItems: 'center', justifyContent: "center"}}>
                        <Text>
                            {T("This feature requires phone verification to operate. Do you want to continue?")}
                        </Text>
                        <ContainerRow>
                            <FormButtonCancel2 style={{marginRight: 8}}
                                               onClick={() => onClose()}>{T("Back")}</FormButtonCancel2>
                            <FormButton2 style={{marginLeft: 8}} onClick={() => {
                                setMode("verify")
                            }}>{T("Continue")}</FormButton2>
                        </ContainerRow>
                    </ContainerRow>
                )}

            </ModalContent>
        </Modal>
    )
}